import { v4 as uuidv4 } from "uuid";

export class ErrorMessage {
  id = null;
  autohide = true;
  dismissed = false;
  dismissible = true;
  duration = 2000;
  message = null;
  title = null;
  variant = "light";

  constructor({
    autohide = true,
    dismissible = true,
    duration = 2000,
    message = null,
    title = null,
    variant = "light",
  } = {}) {
    this.id = uuidv4();
    this.autohide = autohide;
    this.dismissible = dismissible;
    this.duration = duration;
    this.message = message;
    this.title = title;
    this.variant = variant;
  }
}
